import { FaEnvelope, FaMapMarkedAlt, FaPhoneAlt } from 'react-icons/fa';

const contacts = [  
    {
        id: 1, 
        icon: <FaPhoneAlt />,
        title: 'contact.call_us',
        content: [ '+48 668-572-288'],
    },
    {
        id: 2,
        icon: <FaEnvelope />,
        title: 'contact.send_email',
        content: [ 'info@dworimielno.com'],
    },
    {
        id: 3,
        icon: <FaMapMarkedAlt />,
        title: 'contact.garden_name',
        content: ['Imielno 18 99-350 Ostrowy'],
    }

];

export default contacts;